function IconArrowUpRight(props) {
	return (
		<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0996 3.90375C12.3353 4.13945 12.3353 4.61086 12.0996 4.84656L4.55709 12.389C4.32138 12.6247 3.84998 12.6247 3.61428 12.389C3.37857 12.1533 3.37857 11.6819 3.61428 11.4462L11.1567 3.90375C11.3925 3.66805 11.8639 3.66805 12.0996 3.90375Z"
				fill="currentColor"
			/>
			<path
				d="M11.9048 10.9761C11.5378 10.9761 11.2402 10.6787 11.2399 10.3116L11.2357 4.76767L5.69172 4.76346C5.32468 4.76318 5.02729 4.46556 5.02729 4.09853C5.02729 3.73129 5.32499 3.43359 5.69222 3.43359L11.9031 3.43359C12.2713 3.43359 12.5698 3.73207 12.5698 4.10026L12.5698 10.3111C12.5698 10.6784 12.2721 10.9761 11.9048 10.9761Z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default IconArrowUpRight;
